import React from "react";

const WishlistHeart: React.FC<{
  filled: boolean;
  color?: "blue" | "green" | "darkgrey";
  outlineColor?: "blue" | "green" | "darkgrey";
  size?: "big" | "small";
}> = ({filled = false, color = "green", outlineColor = "darkgrey", size = "big"}) => (
  <span
    className={`icon icon-heart${
      filled ? `--${color}` : outlineColor !== "darkgrey" ? `--${outlineColor}--outline` : ""
    } ${size === "big" ? "icon-size--28" : "icon-size--22"}`}
  />
);

export default WishlistHeart;
